const defaultServerError = 'Server request failed';

function combineWithDefaultHeaders(method, headers = {}) {
  const hasBody = method === 'POST' || method === 'PATCH' || method === 'DELETE';
  return hasBody ? { 'Content-Type': 'application/json', ...headers } : headers;
}

const request = {
  delete(url, payload, headers) {
    return request.withErrorHandling('DELETE', url, payload, headers);
  },
  async get(url, headers) {
    try {
      const response = await request.withErrorHandling('GET', url, null, headers);
      return response;
    } catch (e) {
      if (e.status === 401) {
        const response = await request.withErrorHandling('GET', url, null, headers);
        return response;
      }
      throw e;
    }
  },
  post(url, payload, headers) {
    return request.withErrorHandling('POST', url, payload, headers);
  },
  patch(url, payload, headers) {
    return request.withErrorHandling('PATCH', url, payload, headers);
  },
  withErrorHandling(method, url, payload, headers) {
    let status;
    return fetch(url, {
      method,
      body: payload ? JSON.stringify(payload) : null,
      headers: combineWithDefaultHeaders(method, headers),
    }).then((response) => {
      ({ status } = response);
      if (response.status >= 200 && response.status < 300) {
        const clonedResponse = response.clone();
        return response.json().catch(() => clonedResponse.text()).catch((e) => e);
      }
      return response.json().then((errResponse) => {
        const message = errResponse?.message || errResponse?.error?.message || defaultServerError;
        const error = new Error(message);
        error.status = status;
        error.errors = errResponse?.errors;
        throw error;
      }, () => {
        const error = new Error(defaultServerError);
        throw error;
      });
    });
  },
};

export default request;
